import React, { useEffect, useRef, useState } from "react";
import "./ElastiTote.css";

const ElastiTote = () => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const items = [
    { title: "ElastiTote", image: "/images/elastitote/Tote.png" },
    { title: "ElastiBand", image: "/images/elastitote/Band.png" },
    { title: "ElastiTag", image: "/images/elastitote/Tag.png" },
    { title: "Marquee", image: "/images/elastitote/Marquee.png" },
    { title: "ElastiTab", image: "/images/elastitote/Tab.png" },
  ];

  // 🔹 Detectar visibilidad
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) setIsVisible(true);
      },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  // 🔹 Cambio automático cada 15 seg
  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 15000);
    return () => clearInterval(interval);
  }, []);

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % items.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + items.length) % items.length);
  };

  const { title, image } = items[currentIndex];

  return (
    <>
      <h2 className="holo-title">
        Lo último en innovación{" "}
        <img src="../images/logo/Logo Moti.svg" alt="Logo Moti" />
      </h2>

      <section
        ref={ref}
        className={`elastitote-container ${isVisible ? "visible" : ""}`}
      >
        {/* 🔹 Botón Anterior */}
        <button className="nav-btn side prev" onClick={handlePrev}>
          ◀
        </button>

        {/* Lado izquierdo */}
        <div className="left-card">
          <img
            key={image}
            src={image}
            alt={title}
            className="bottle-img fade-in"
          />
          <h3 className="vertical-text">ElastiTag®</h3>
        </div>

        {/* Lado derecho */}
        <div className="right-card">
          <h2 key={title} className="title fade-in">
            {title}
          </h2>
          <p className="subtitle-home">Cotiza con tu ejecutivo</p>

          <div className="options">
            <span className="options-label">ELIGE TU ELASTITAG®</span>
            <div className="icons">
              <img src="/images/elastitote/Tag.svg" alt="opcion1" />
              <img src="/images/elastitote/Band.svg" alt="opcion2" />
              <img src="/images/elastitote/Marquee.svg" alt="opcion3" />
              <img src="/images/elastitote/Tote.svg" alt="opcion4" />
              <img src="/images/elastitote/Tab.svg" alt="opcion5" />
            </div>
          </div>

          <button 
  className="cta-btn"
  onClick={() => window.open("https://api.whatsapp.com/send/?phone=%2B5213323104081&text&type=phone_number&app_absent=0", "_blank")}
>
  COTIZA AHORA
</button>
        </div>

        {/* 🔹 Botón Siguiente */}
        <button className="nav-btn side next" onClick={handleNext}>
          ▶
        </button>
      </section>

    </>
  );
};

export default ElastiTote;
